<template>
   <div class="section">
    <div class="_1200 w-clearfix">
      <h2 class="sec-heading">תכניות הלימודים</h2>
      <a v-if="$parent.user" v-on:click="createHalufa()" class="btn light add-side user w-button">יצירת חלופה חדשה</a>
      </div>
    <div class="_1200 flex">
      <div class="tags-box"><a v-for="unit in units" :key="unit.id" v-bind:class="unit.id == activeUnit?'w--current':''" v-on:click="activeUnit = unit.id" href="#" class="tag"><strong>{{unit.name}}</strong></a></div>
      <div class="collection-list-wrapper">
        <div class="collection-list-flex">
          <div v-for="halufa in halufot" :key="halufa.id" class="collection-item w-embed">
            <router-link :to="'/alternative/'+halufa.id" class="white-box w-inline-block">
              <div class="white-box-head-box">
                <h3 class="white-box-head space">{{halufa.name}}</h3>
                <h3 class="white-box-above-head">{{halufa.author}}</h3>
              </div>
              <div class="innertxt-box">
                <p class="white-box-txt">{{halufa.description}}</p>
              </div>
              <img src="images/bookmark.svg" alt="" class="bookmark hide">
            </router-link>
          </div>
        </div>
        <div class="white-box empty new">
          
	<div class="container--box">
		<div class="box">
			<div v-if="loader" class="spinner spinner--2"></div>
		</div>
	</div>

        </div>
        <div v-if="halufot.length == 0 && units && !loader" class="white-box empty new">
          <p class="empty-txt">עדיין לא הועלו חלופות</p>
          
          </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.container--box .box {
	display: grid;
	justify-items: center;
	align-items: center;
	height:100%;
}
.container--box .box .spinner {
	height: 40px;
	width: 40px;
	background: transparent;
	border-radius: 100%;
}

.container--box .box .spinner--2 {
	border: 3px solid #239fff;
	border-top-color: #fff;
	animation: spinner2 600ms linear infinite;
}
@keyframes spinner2 {
	to {
		transform: rotate(360deg);
	}
}
</style>

<script>
import { setTimeout } from 'timers';
// @ is an alias to /src

export default {
  name: 'alternatives',
  data(){
      return{
      user:'',
      units:[],
      search:'',
      activeUnit:'',
      halufot:[],
      loader:true
      }
    },
    methods:{
      link(link){
        window.location = link;
      },
      searchFunc(obj,child,term){
        var include={}
        $.each(obj,(i,e)=>{
          if (e[child].match(new RegExp(term, 'gi'))){
            include[i]=e;
          }
        });
        return include
      },
      getHalufa(){
          db.collection("/collections/oVwbkKRU39ykpil2lw62/items").where("unit", "==", this.activeUnit).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                var data = doc.data()
                data.id = doc.id
                this.halufot.push(data)
            })
            this.loader = false
          })
      },
      createHalufa(){
        var haluf = {
            name:'',
            author:this.user.name,
            chapters:[],
            unit:this.activeUnit,
            created: new Date(),
            _draft:true
        }
        db.collection("/collections/oVwbkKRU39ykpil2lw62/items").add(haluf).then((doc)=>{
            console.log("halufa created")
            if (!this.$parent.user.halufot){
              this.$parent.user.halufot = []
            }
            this.$parent.user.halufot.push(doc.id)
            console.log(this.$parent.user.halufot)
            db.doc('/collections/nZSsggipwqsg74x8nJBu/items/'+this.user.uid).update({
                halufot:this.$parent.user.halufot
            }).then(()=>{
                this.$router.push('/alternative/'+doc.id+'?edit')
            })
        })
      }
    },
    mounted(){
        firebase.auth().onAuthStateChanged((user)=>{
            if (user) {
              var uid = user.uid
              db.doc('/collections/nZSsggipwqsg74x8nJBu/items/'+uid).get().then((user)=>{
                this.user = user.data()
                this.user.uid = uid
            })
            }
          });
        db.collection("/collections/08KvFNfzvqAhTx1EQYUM/items").orderBy("name", "asc").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
              var data = doc.data()
              data.id = doc.id
              this.units.push(data)
          });
        this.activeUnit = this.units[0].id
      });
      },
      computed:{
        busFilter(){
          if (!this.search){
            return(this.businesses);
          } else {
            //var term = new RegExp(this.selectedUI.search, 'gi')
            //return this.categories.filter((e)=>{e.name.match(term)})
            return this.searchFunc(this.businesses,"businessName",this.search);
          }
        }
      },
      watch:{
        activeUnit(){
          this.loader = true
            this.halufot = []
            this.getHalufa()
        }
      }
}
</script>